// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-e1b585f0] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.color-picker[data-v-e1b585f0] {
  display: flex;
  overflow: hidden;
  align-content: flex-end;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: content-box !important;
  width: 176px;
  padding: 8px;
  border-radius: 3px;
}
.color-picker--advanced-fields[data-v-e1b585f0] {
  width: 264px;
}
.color-picker__simple[data-v-e1b585f0] {
  display: grid;
  grid-template-columns: repeat(auto-fit, 44px);
  grid-auto-rows: 44px;
}
.color-picker__simple-color-circle[data-v-e1b585f0] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  min-height: 34px;
  margin: auto;
  padding: 0;
  color: white;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  font-size: 16px;
}
.color-picker__simple-color-circle[data-v-e1b585f0]:focus-within {
  outline: 2px solid var(--color-main-text);
}
.color-picker__simple-color-circle[data-v-e1b585f0]:hover {
  opacity: 0.6;
}
.color-picker__simple-color-circle--active[data-v-e1b585f0] {
  width: 38px;
  height: 38px;
  min-height: 38px;
  transition: all 100ms ease-in-out;
  opacity: 1 !important;
}
.color-picker__advanced[data-v-e1b585f0] {
  box-shadow: none !important;
}
.color-picker__navigation[data-v-e1b585f0] {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
[data-v-e1b585f0]  .vc-chrome {
  width: unset;
  background-color: var(--color-main-background);
}
[data-v-e1b585f0]  .vc-chrome-color-wrap {
  width: 30px;
  height: 30px;
}
[data-v-e1b585f0]  .vc-chrome-active-color {
  width: 34px;
  height: 34px;
  border-radius: 17px;
}
[data-v-e1b585f0]  .vc-chrome-body {
  padding: 14px 0 0 0;
  background-color: var(--color-main-background);
}
[data-v-e1b585f0]  .vc-chrome-body .vc-input__input {
  box-shadow: none;
}
[data-v-e1b585f0]  .vc-chrome-toggle-btn {
  filter: var(--background-invert-if-dark);
}
[data-v-e1b585f0]  .vc-chrome-saturation-wrap {
  border-radius: 3px;
}
[data-v-e1b585f0]  .vc-chrome-saturation-circle {
  width: 20px;
  height: 20px;
}
.slide-enter[data-v-e1b585f0] {
  transform: translateX(-50%);
  opacity: 0;
}
.slide-enter-to[data-v-e1b585f0] {
  transform: translateX(0);
  opacity: 1;
}
.slide-leave[data-v-e1b585f0] {
  transform: translateX(0);
  opacity: 1;
}
.slide-leave-to[data-v-e1b585f0] {
  transform: translateX(-50%);
  opacity: 0;
}
.slide-enter-active[data-v-e1b585f0], .slide-leave-active[data-v-e1b585f0] {
  transition: all 50ms ease-in-out;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcColorPicker-DH3H7HLS.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,8BAA8B;EAC9B,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,6CAA6C;EAC7C,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,gCAAgC;AAClC","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-e1b585f0] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.color-picker[data-v-e1b585f0] {\n  display: flex;\n  overflow: hidden;\n  align-content: flex-end;\n  flex-direction: column;\n  justify-content: space-between;\n  box-sizing: content-box !important;\n  width: 176px;\n  padding: 8px;\n  border-radius: 3px;\n}\n.color-picker--advanced-fields[data-v-e1b585f0] {\n  width: 264px;\n}\n.color-picker__simple[data-v-e1b585f0] {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, 44px);\n  grid-auto-rows: 44px;\n}\n.color-picker__simple-color-circle[data-v-e1b585f0] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  min-height: 34px;\n  margin: auto;\n  padding: 0;\n  color: white;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  border-radius: 50%;\n  font-size: 16px;\n}\n.color-picker__simple-color-circle[data-v-e1b585f0]:focus-within {\n  outline: 2px solid var(--color-main-text);\n}\n.color-picker__simple-color-circle[data-v-e1b585f0]:hover {\n  opacity: 0.6;\n}\n.color-picker__simple-color-circle--active[data-v-e1b585f0] {\n  width: 38px;\n  height: 38px;\n  min-height: 38px;\n  transition: all 100ms ease-in-out;\n  opacity: 1 !important;\n}\n.color-picker__advanced[data-v-e1b585f0] {\n  box-shadow: none !important;\n}\n.color-picker__navigation[data-v-e1b585f0] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n[data-v-e1b585f0]  .vc-chrome {\n  width: unset;\n  background-color: var(--color-main-background);\n}\n[data-v-e1b585f0]  .vc-chrome-color-wrap {\n  width: 30px;\n  height: 30px;\n}\n[data-v-e1b585f0]  .vc-chrome-active-color {\n  width: 34px;\n  height: 34px;\n  border-radius: 17px;\n}\n[data-v-e1b585f0]  .vc-chrome-body {\n  padding: 14px 0 0 0;\n  background-color: var(--color-main-background);\n}\n[data-v-e1b585f0]  .vc-chrome-body .vc-input__input {\n  box-shadow: none;\n}\n[data-v-e1b585f0]  .vc-chrome-toggle-btn {\n  filter: var(--background-invert-if-dark);\n}\n[data-v-e1b585f0]  .vc-chrome-saturation-wrap {\n  border-radius: 3px;\n}\n[data-v-e1b585f0]  .vc-chrome-saturation-circle {\n  width: 20px;\n  height: 20px;\n}\n.slide-enter[data-v-e1b585f0] {\n  transform: translateX(-50%);\n  opacity: 0;\n}\n.slide-enter-to[data-v-e1b585f0] {\n  transform: translateX(0);\n  opacity: 1;\n}\n.slide-leave[data-v-e1b585f0] {\n  transform: translateX(0);\n  opacity: 1;\n}\n.slide-leave-to[data-v-e1b585f0] {\n  transform: translateX(-50%);\n  opacity: 0;\n}\n.slide-enter-active[data-v-e1b585f0], .slide-leave-active[data-v-e1b585f0] {\n  transition: all 50ms ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
